module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin leer 5.8f04f203.svg";